import { useQuery } from "@tanstack/react-query";
import { getBundlesGrouped } from "../services/get-bundles-grouped";
import { useRegionFilter } from "@/features/regions/hooks/use-region-filter";
import { GroupedBundlesResponse } from "@/pages/bundles/types/grouped-bundle";

export default function useBundlesGrouped({ q }: { q?: string }) {
  const region = useRegionFilter();

  return useQuery<GroupedBundlesResponse>({
    queryKey: ["bundles", "grouped", { region, q }],
    queryFn: () => getBundlesGrouped({ region, q }),
    refetchOnWindowFocus: false,
    staleTime: 1000 * 60 * 5,
  });
}
